import { render, staticRenderFns } from "./meeting-list.vue?vue&type=template&id=2c330887&scoped=true"
import script from "./meeting-list.vue?vue&type=script&lang=js"
export * from "./meeting-list.vue?vue&type=script&lang=js"
import style0 from "./meeting-list.vue?vue&type=style&index=0&id=2c330887&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c330887",
  null
  
)

export default component.exports